import { render } from "./FormPenyusunan.vue?vue&type=template&id=1c5c6ba2"
import script from "./FormPenyusunan.vue?vue&type=script&lang=js"
export * from "./FormPenyusunan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__